import React, {PureComponent} from 'react';
import createDOMPurify from 'dompurify';

import caretXY from 'components/helpers/caretXY';

const DROPDOWN_X_OFFSET = 5;
const DROPDOWN_Y_OFFSET = 15;

import getDisplayName from 'components/helpers/getDisplayName';
import {isMobileAndroid} from 'sources/webrtc/streams/browserDetector';

export default function withMacro(WrappedComponent) {
    return class extends PureComponent {
        static displayName = `withMacro(${getDisplayName(WrappedComponent)})`;
        state = {
            macro: '',
        };


        handleUpdateMacro = (e, clearState) => {
            if (clearState) {
                this.setState({
                    macro: '',
                    macroDropDownPosition: {left: 0, top: 0}

                });

                return;
            }

            const {target} = e;
            const macro = this.getNewMacro(target);
            const macroDropDownPosition = isMobileAndroid() && this.getNewDropdownPosition(target, macro);


            this.setState({
                macro,
                macroDropDownPosition,
                caretPosition: target.selectionEnd,
            });
        };

        getNewDropdownPosition = (target, macro) => {
            if (macro && macro.length) {
                const caretPosition = caretXY(target);

                return {
                    left: caretPosition.left + DROPDOWN_X_OFFSET,
                    top: caretPosition.top + DROPDOWN_Y_OFFSET
                }
            }

            return {
                top: 0,
                left: 0,
            }
        };



        getNewMacro = (target) => {
            const {selectionStart} = target;
            const value = target.value.value || target.value;
            const DOMPurify = createDOMPurify(window);
            const escapedValue = DOMPurify.sanitize(value, {ALLOWED_TAGS: []});
            const words = escapedValue.slice(0, selectionStart).split(' ');
            const lastWord = words[words.length - 1];
            if (lastWord.indexOf('#') === -1) {
                return '';
            }
            const macros = lastWord.split('#');
            return macros[macros.length - 1];
        };

        render() {
            const {macro, macroDropDownPosition} = this.state;

            return (
                <WrappedComponent
                    {...this.props}
                    macro={macro}
                    macroDropDownPosition={macroDropDownPosition}
                    onUpdateMacro={this.handleUpdateMacro}
                />
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/controls/hoc/withMacro.js